import { useTheme } from "@mui/material";
import { createCallToActionProps } from "../utils/linkUtils";
import { HeroSectionProps } from "../types";

export const useHeroSection = (options: HeroSectionProps) => {
    const { title, subtitle, description, imageUrl, ctaLabel, ctaLink } = options;
    const theme = useTheme();

    const callToActionProps = createCallToActionProps(ctaLabel, ctaLink);

    const descriptionStyles = {
        fontFamily: theme.typography.fontFamily,
        "& a": {
            color: theme.palette.primary.main,
            textDecoration: "underline",
            "&:hover": {
                textDecoration: "none",
            },
        },
    };

    return {
        title,
        subtitle,
        description,
        imageUrl,
        callToActionProps,
        descriptionStyles,
    };
};
